import styled, { keyframes } from 'styled-components';
import { backgroundTheme, media } from '../../styles/style-utils';

export const StyledWrapper = styled.div`
  padding: 0;
  background: ${props => backgroundTheme(props.themeColors)};
  color: ${props => props.textColor};

  > section {
    padding: 4rem 2rem;
  }
`;

export const LeaderboardsWrapper = styled.section`
  margin: 4rem 0 0;
  text-align: center;

  > h1 {
    margin: 2rem 0;
  }

  > div {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0 0 2rem 0;

    ul {
      border-left-color: ${props => props.textColor};
    }
  }

`;

export const TopSection = styled.section`
  padding: 8rem 1rem;
  margin: 5rem 0 4rem 0;
  position: relative;
  display: flex;
  flex-direction: column;

  ${media.fromMedium`flex-direction: row;`}
`;

export const TitleSection = styled.section`
  width: 100%;
  ${media.fromMedium`
    width: 50%;
    padding-right: 4rem;
    margin-top: 0rem;
  `}
  ${media.fromLarge`width: 60%`}
`;

export const CenteredHeading = styled.div`
  text-align: center;
  margin: 2rem 0 2rem;
`;

export const NutrientsSection = styled.section`
  width: 100%;
  ${media.fromMedium`width: 50%`}
  ${media.fromLarge`width: 40%`}
`;

export const NutrientsHeader = styled.header`
  ${media.fromMedium`padding-left: 100px;`}

  i {
    font-size: 1rem;
  }
`;

export const MissingNutrientText = styled.p`
  ${media.fromMedium`margin-left: 100px;`}

  padding: 1rem;
  border: 1px dashed ${props => props.textColor};
`;

export const ServingText = styled.p`
  display: inline-block;
  position: relative;
`

export const HomeLinkWrap = styled.div`
  position: absolute;
  display: block;
  width: 100px;
  font-size: 2rem;
  line-height: 2rem;
  padding: 1rem;
  top: -5rem;
  left: 0;
  border-bottom: 1px solid ${props => props.textColor};

  > a {
    color: ${props => props.textColor};
  }
`;

export const CardsSection = styled.section`
  display: grid;
  grid-template-columns: 100%;
  ${media.fromSmall`
    grid-auto-rows: 1fr;
    grid-template-columns: 50% 50%;`
  }
  ${media.fromMedium``}
  ${media.fromLarge`
    grid-template-columns: 33% 33% 34%;
  `};
  ${media.fromXLarge`grid-template-columns: 20% 20% 20% 20% 20%;`}

  margin-top: 4rem;

  > section {
    padding: 0 0 3rem;

    ${media.fromSmall`
      padding: 0 1rem 1rem 0;
    `}

    > div {
      ${media.fromSmall`
        border-left: 1px solid ${props => props.textColor};
      `};

      > h2 {
        position: relative;
        left: -1rem;
        padding: 0 0 1rem 1rem;
        border-bottom: 1px solid ${props => props.textColor};
      }
    }
  }
`;

export const ResearchSection = styled.section`
  background: rgb(255, 255, 255);
  color: black;
  text-align: center;

  > h1 {
    margin: 2rem 0 4rem;
  }
`;

const spinLogoAnimation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const AbstractLogosSectionTop = styled.section`
  height: 50px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0));
  position: relative;
  padding: 0 2rem;

  > div {
    position: absolute;
    bottom: -100px;
    left: 50px;
  }

  .logo {
    animation: ${spinLogoAnimation} 12s linear infinite;
  }
`;

export const AbstractLogosSectionBottom = styled.section`
  height: 50px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0));
  position: relative;
  padding: 0 2rem;

  > div {
    position: absolute;
    top: -100px;
    right: 50px;
  }

  .logo {
    animation: ${spinLogoAnimation} 12s linear infinite reverse;
  }
`;

export const TooMuchSection = styled.section`
  padding:  2rem 2rem 6rem !important;
  background: white;
  color: black;

  p {
    max-width: 900px;
    margin: 0 auto;
  }
`;

export const BuySection = styled.section`
`;



// WEBPACK FOOTER //
// ./src/templates/FoodTemplate/FoodTemplateStyles.js